import ReactMarkdown from 'react-markdown';
import { css } from 'linaria';
const introStyles = "iy7gc6s";
export const ContentIntro = function ({
  intro
}) {
  return <div className={introStyles}>
      <ReactMarkdown>{intro}</ReactMarkdown>
    </div>;
};

require("./content-intro.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./content-intro.js");